
/*
 * ! @chakra-ui/vue v0.13.1 by Jonathan Bakebwa @codebender828
 * MIT License
 * https://github.com/chakra-ui/chakra-ui-vue
 */

import { R as createStyledAttrsMixin } from './index-2216d089.js';
import { i as internalIcons } from './internal-icons-3bdf43cd.js';
import { css } from '@emotion/css';

var iconProps = {
  name: {
    type: [String, Array]
  },
  use: {
    type: [String, Array],
    required: false
  },
  pack: {
    type: String,
    required: false,
    default: 'fas',
    validator: function validator(value) {
      return value.match(/^(fas|fal|fad)$/);
    }
  },
  size: {
    type: [String, Number, Array],
    default: '1em'
  }
};

/**
 * Hey! Welcome to @chakra-ui/vue Icon
 *
 * CIcon is used for rendering icons.
 *
 * Use the <CIcon> component to easily render <svg> icons.
 *
 * @see Docs     https://vue.chakra-ui.com/icon
 * @see Source   https://github.com/chakra-ui/chakra-ui-vue/blob/master/packages/chakra-ui-core/src/CIcon/CIcon.js
 */
var templateObject = Object.freeze(["\n        flex-shrink: 0;\n        backface-visibility: hidden;\n        &:not(:root) {\n          overflow: hidden;\n        }\n      "]);
var fallbackIcon = internalIcons['question-outline'];
var Svg = {
  name: 'ChakraIconSvg',
  mixins: [createStyledAttrsMixin('ChakraIconSvg')],
  props: iconProps,
  computed: {
    svgClassName: function svgClassName() {
      return css(templateObject);
    }
  },
  render: function render(h) {
    return h('svg', {
      class: [this.svgClassName, this.className],
      attrs: this.computedAttrs
    }, this.$slots.default);
  }
};
/**
 * CIcon component
 *
 * CIcon is used for rendering icons.
 *
 * @extends CBox
 * @see Docs https://vue.chakra-ui.com/icon
 */

var CIcon = {
  name: 'CIcon',
  mixins: [createStyledAttrsMixin('CIcon')],
  inject: ['$chakraIcons'],
  computed: {
    icon: function icon() {
      var icon;

      if (this.name) {
        icon = this.$chakraIcons[this.name];
      } else {
        console.warn('[Chakra]: You need to provide the "name" or "use" prop to for the Icon component');
      }

      if (!icon) {
        icon = fallbackIcon;
      }

      return icon;
    },
    viewBox: function viewBox() {
      return this.icon.viewBox || '0 0 24 24';
    }
  },
  props: iconProps,
  render: function render(h) {
    return h(Svg, {
      class: this.className,
      attrs: Object.assign({}, this.icon.attrs || {}, {
        w: this.size,
        h: this.size,
        color: this.color,
        d: 'inline-block',
        verticalAlign: 'middle',
        viewBox: this.viewBox,
        role: 'presentation',
        focusable: false
      }, this.computedAttrs),
      domProps: {
        innerHTML: this.icon.path
      }
    });
  }
};

export { CIcon as C, iconProps as i };
